// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i0-0";
export var actionModalContentContainer = "_i0-1";
export var createTagButton = "_i0-2";
export var footerContainer = "_i0-7";
export var fullWidthDivider = "_i0-3";
export var hasCreateTagButton = "_i0-4";
export var noCreateTagButton = "_i0-5";
export var tagsContainer = "_i0-6";
export var tagsModalContentContainer = "_i0-8";